module.exports = __webpack_public_path__ + "videos/mts-products-chats-account-management.b220a8a.webm";